// extracted by mini-css-extract-plugin
module.exports = {"iconColor":"#fbf4ed","text":"#412304","lightBrown":"#e3c19a"};